// exclude-from-index
import React from 'react';
import PropTypes from 'prop-types';
import { StyledLink } from './NavLink.styles';
import { IsTouchEnabledConsumer } from '../Context';
import { ReactChildrenPropType } from '../../../../../lib/commonPropTypes';

function NavLink(props) {
  const { children } = props;

  return (
    <IsTouchEnabledConsumer>
      {({ isTouchDevice }) => (
        <StyledLink {...props} isTouchDevice={isTouchDevice}>
          {children}
        </StyledLink>
      )}
    </IsTouchEnabledConsumer>
  );
}

NavLink.propTypes = {
  /**
   * Content of the styled anchor component, usually text based but can also accept SVGs
   */
  children: ReactChildrenPropType,
  /**
   * regular anchor tag href attribute to pass to styled anchor component
   */
  href: PropTypes.string,
  /**
   * regular anchor tag target attribute to pass to styled anchor component
   */
  target: PropTypes.string,
  /**
   * Class's to apply to the anchor tag
   */
  className: PropTypes.string,
  /**
   * function passed to control any required behavior that is not regular routing.
   */
  onClick: PropTypes.func
};

NavLink.defaultProps = {
  children: null,
  href: '',
  target: '',
  className: '',
  onClick: () => {}
};

export default NavLink;
